import { DEFAULT_MAX_WIDTH_XL } from '@dbh/styled-helpers';

/*
 *
 * Package: `@dbh/search-box-theme`.
 *
 */const THEME_KEY_SEARCH_BOX="searchBox";const modifySearchBoxTheme=a=>{const{colors:{blackMid:c,brandFirst:d},[THEME_KEY_SEARCH_BOX]:b}=a;return {...a,[THEME_KEY_SEARCH_BOX]:{...b,tabs:{color:c,active:{borderColor:d}},searchboxForm:{maxWidth:DEFAULT_MAX_WIDTH_XL}}}};

export { THEME_KEY_SEARCH_BOX, modifySearchBoxTheme as default };
